//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscTableFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 21H11V17H3V21ZM13 15H21V11H13V15ZM3 3V9H21V3H3ZM3 15H11V11H3V15ZM13 21H21V17H13V21Z" fill="currentColor" /></svg>;
}
export default IconMiscTableFill;